export default __webpack_public_path__ + "static/aws-cloud-practitioner-logo-20b5425c694a3e79717beab87770d799.png";